import LoginForm from "../../forms/AuthForm/LoginForm";

const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
